import Vue from 'vue';
import Router from 'vue-router';
import Tags from './components/Tags';

import Register from './components/user/Register';
import Login from './components/user/Login';
import Logout from './components/user/Logout';
import ForgotPassword from './components/user/ForgotPassword';
import ResetPassword from './components/user/ResetPassword';
import ConfirmEmail from './components/user/ConfirmEmail';
import Profile from './components/profile/Profile';
import EditProfessionalProfile from './components/profile/EditProfessionalProfile';
import EditMemberProfile from './components/profile/EditMemberProfile';
import Search from './components/search/Search';
import AskQuestions from './components/member/AskQuestions';
import Home from './components/home-v2/Home';
import About from './components/home/About';
import HowItWorks from './components/how-it-works/HowItWorks';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminTag from './components/admin/AdminTag';
import AdminQuestion from './components/admin/AdminQuestion';
import AdminUsers from './components/admin/AdminUsers';
import AdminQuestions from './components/admin/AdminQuestions';
import AdminTags from './components/admin/AdminTags';
import AdminCategories from './components/admin/AdminCategories';
import AdminCategory from './components/admin/AdminCategory';
import AdminLoginAs from './components/admin/AdminLoginAs';
import AdminSubscriptionTypes from './components/admin/AdminSubscriptionTypes';
import AdminProduct from './components/admin/AdminProduct';
import AdminSubscriptionType from './components/admin/AdminSubscriptionType';
import StripeCancel from './components/stripe/StripeCancel';
import StripeSuccess from './components/stripe/StripeSuccess';
import StripeSubscriptions from './components/stripe/StripeSubscriptions';
import StripeAccount from './components/stripe/StripeAccount';
import StripeAccountSuccess from './components/stripe/StripeAccountSuccess.vue';
import StripeAccountRefresh from './components/stripe/StripeAccountRefresh.vue';
import CreateAppointment from './components/appointment/CreateAppointment';
import AppointmentsList from './components/appointment/AppointmentsList';
import Appointment from './components/appointment/Appointment';
import RescheduleAppointment from './components/appointment/RescheduleAppointment';
import ZipcodeOrCity from './components/member/ZipcodeOrCity';
import Chat from './components/chat/Chat';
import ChatsList from './components/chat/ChatsList';
import ReviewsList from './components/review/ReviewsList';
import Product from './components/product/PublicProductsList';
import loginStore from '@/util/loginStore';
import PreviewProduct from './components/product/PreviewProduct';
import Settings from './components/settings/Settings';
import TermsPage from './components/legal/terms/TermsPage';
import PrivacyPage from './components/legal/privacy-policy/PrivacyPolicy';
import CookiePage from './components/legal/cookie-policy/CookiePolicy';
import DisclaimerPage from './components/legal/disclaimer/DisclaimerPage';
import FaqPage from './components/faq/FaqPage';
import AboutPage from './components/about/AboutPage';

/* eslint-disable no-debugger */

Vue.use(Router);
Vue.component('ask-questions', AskQuestions);
Vue.component('zipcodeorcity', ZipcodeOrCity);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/products',
      name: 'Product',
      component: Product,
      meta: { requiresAuth: true }
    },
    {
      path: '/product/:uuid',
      name: 'PreviewProduct',
      component: PreviewProduct,
      props: true
    },
    {
      path: '/about-wlg',
      name: 'About',
      component: About
    },
    {
      path: '/how-it-works',
      name: 'HowItWorks',
      component: HowItWorks
    },
    {
      path: '/tags',
      name: 'tags',
      component: Tags,
      meta: { noAuth: true }
    },
    {
      path: '/register/:registrationType',
      name: 'register',
      component: Register,
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      props: true
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: ForgotPassword
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword
    },
    {
      path: '/confirm-email',
      name: 'confirm-email',
      component: ConfirmEmail
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout,
      meta: { requiresAuth: true }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      props: { mode: 'search' },
      meta: { requiresAuth: false }
    },
    {
      path: '/match',
      name: 'Match',
      component: Search,
      props: { mode: 'match' },
      meta: { requiresAuth: false }
    },
    {
      path: '/profile/member',
      name: 'edit-member',
      component: EditMemberProfile,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/profile/edit',
      name: 'edit',
      component: EditProfessionalProfile,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/tag/new',
      name: 'admin-tag-create',
      component: AdminTag,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/tag/:tagId',
      name: 'admin-tag',
      component: AdminTag,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/question/new',
      name: 'admin-question-create',
      component: AdminQuestion,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/question/:questionId',
      name: 'admin-question',
      component: AdminQuestion,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/loginAs/:username',
      name: 'loginAs',
      component: AdminLoginAs,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/category/new',
      name: 'admin-category-create',
      component: AdminCategory,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/category/:categoryId',
      name: 'admin-category',
      component: AdminCategory,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/subscription-type/new',
      name: 'admin-subscription-type-new',
      component: AdminSubscriptionType,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin/subscription-type/:subscriptionTypeId',
      name: 'admin-subscription-type',
      component: AdminSubscriptionType,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/admin',
      name: 'admin',
      component: AdminDashboard,
      props: true,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          redirect: 'users' // default child path
        },
        {
          path: 'tags',
          name: 'admin-tags',
          component: AdminTags,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'questions',
          name: 'admin-questions',
          component: AdminQuestions,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'users',
          name: 'admin-users',
          component: AdminUsers,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'products',
          name: 'admin-product',
          component: AdminProduct,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'categories',
          name: 'admin-categories',
          component: AdminCategories,
          props: true,
          meta: { requiresAuth: true }
        },
        {
          path: 'subscription-types',
          name: 'admin-subscription-types',
          component: AdminSubscriptionTypes,
          props: true,
          meta: { requiresAuth: true }
        }
      ]
    },
    {
      path: '/user/:username',
      name: 'profile-by-username',
      component: Profile,
      props: true
    },
    {
      path: '/stripe/success',
      name: 'stripe-success',
      component: StripeSuccess,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/stripe/cancel',
      name: 'stripe-cancel',
      component: StripeCancel,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/subscriptions',
      name: 'stripe-subscriptions',
      component: StripeSubscriptions,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/stripe/account',
      name: 'stripe/account',
      component: StripeAccount,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/stripe/onboarding/success',
      name: 'stripe/onboarding/success',
      component: StripeAccountSuccess,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/stripe/onboarding/refresh',
      name: 'stripe/onboarding/refresh',
      component: StripeAccountRefresh,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/appointment/create/:username',
      name: 'appointment-create',
      component: CreateAppointment,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/appointment/reschedule/:appointmentUuid',
      name: 'appointment-reschedule',
      component: RescheduleAppointment,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/appointment/list/',
      name: 'appointments-list',
      component: AppointmentsList,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/appointment/:appointmentUuid',
      name: 'appointment',
      component: Appointment,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/chat/:username',
      name: 'chat',
      component: Chat,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/chats',
      name: 'chats',
      component: ChatsList,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/settings',
      name: 'settings',
      component: Settings,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/reviews/:username',
      name: 'reviews',
      component: ReviewsList,
      props: true,
      meta: { requiresAuth: true }
    },
    {
      path: '/terms',
      name: 'terms',
      component: TermsPage
    },
    {
      path: '/privacy-policy',
      name: 'privacy-policy',
      component: PrivacyPage
    },
    {
      path: '/cookie-policy',
      name: 'cookie-policy',
      component: CookiePage
    },
    {
      path: '/disclaimer',
      name: 'disclaimer',
      component: DisclaimerPage
    },
    {
      path: '/faq',
      name: 'faq',
      component: FaqPage
    },
    {
      path: '/about',
      name: 'about',
      component: AboutPage
    }
  ]
});

// IMPORTANT: This navigation guard must run BEFORE the auth guard
// Remove trailing slashes to prevent 404 errors on page reload
router.beforeEach((to, from, next) => {
  // Handle trailing slash removal (except for root path)
  if (to.path !== '/' && to.path.endsWith('/')) {
    const pathWithoutTrailingSlash = to.path.slice(0, -1);
    next({
      path: pathWithoutTrailingSlash,
      query: to.query,
      hash: to.hash,
      replace: true // Don't add to browser history
    });
    return; // Important: exit early after redirect
  }

  // Authentication guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!loginStore.loggedIn) {
      next({
        path: '/login',
        query: { nextUrl: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (!loginStore.loggedIn) {
      next();
    } else {
      next({ name: 'dashboard' });
    }
  } else {
    next();
  }
});

export default router;
